module.exports = __webpack_public_path__ + "img/findupix-logo-svg.147e1017.svg";